import Icon from 'molecules/Icon';
import { IconIds } from 'molecules/Icon/types';

import type { FC } from 'react';

export interface TextInputProps {
  /**
   * Indicates whether the text input should be disabled and not interactive.
   */
  disabled?: boolean;
  /**
   * Specifies the icon to display in the text input field.
   */
  icon?: IconIds;
  /**
   * Specifies the icon to display at the end of the text input field.
   */
  endIcon?: IconIds;
  /**
   * Specifies the name of the text input field.
   */
  name?: string;
  /**
   * Specifies the placeholder text to display in the text input field when it is empty.
   */
  placeholder?: string;
  /**
   * Callback function that is called when the value of the text input field changes.
   * @param event - The React change event object containing the new value of the input field.
   */
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  /**
   * Specifies the value of the text input field.
   */
  value?: string;
}

const TextInput: FC<TextInputProps> = ({ disabled, icon, endIcon, name, placeholder, ...props }) => (
  <div
    data-disabled={disabled}
    className="flex gap-2 rounded-lg border border-gray-50 bg-gray-25 p-[11px] shadow-xs focus-within:stateful-outline-tealCustom"
  >
    {icon && <Icon icon={icon} size={20} className="stroke-2" />}
    <input
      name={name}
      disabled={disabled}
      placeholder={placeholder}
      className="w-full bg-transparent text-md text-gray-900 placeholder:text-gray-600 focus-visible:outline-none disabled:cursor-not-allowed"
      aria-label={placeholder || 'Text input'}
      {...props}
    />
    <div className="text-primary-700">{endIcon && <Icon icon={endIcon} size={20} className="stroke-2" />}</div>
  </div>
);

export default TextInput;
